import React, { useState } from "react";
import { caseStudiesProcess } from "./CaseStudyData";
import { Col, Container, Row } from "react-bootstrap";
import MajorClient from "../Home/Components/MajorClient";
import Testimonials from "../Home/Components/Testimonials";
import { PiArrowBendDownRightBold } from "react-icons/pi";
import { IoMdStar } from "react-icons/io";
import client from "../../Images/CaseStudies/client-benifit.webp";
import Image5 from "../../Images/CaseStudies/Auxilo.webp";

const AuxiloNetwork = () => {
  const [tabName, setTabName] = useState("Business Needs");

  return (
    <div>
      <div className="case_study_details case_study">
        <Container>
          <Row className="justify-content-center">
            <Col lg={11} className="case_content text-center">
              <h1>
                <span>Auxilo Network</span>
              </h1>
            </Col>
          </Row>
        </Container>
      </div>

      <Container>
        <Row>
          <Col lg={12}>
            <div className="industrial">
              <img src={Image5} alt={Image5} className="img-fluid" />
              <div className="industrial_content">
                <p>
                  Auxilo Network is an advanced safety and emergency management platform built to link citizens, police departments, and agents for rapid, real-time emergency responses. The platform offers tools like a live crime map, a sex offender registry map, and an efficient emergency reporting system, allowing users to quickly report incidents. By fostering real-time collaboration between agents and departments, Auxilo Network improves public safety and empowers citizens with the resources they need to take control of their own safety.
                </p>
                <div className="d-flex flex-wrap align-items-center justify-content-between ">
                  <div>
                    <h4>Industry</h4>
                    <p>
                      <b>Public Safety & Emergency Management</b>
                    </p>
                  </div>
                  <div>
                    <h4>Country</h4>
                    <p>
                      <b>United States (Global Operations Supported)</b>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <hr className="m-0" />
      <div className="case_img_box">
        <Container>
          <div className="case_box position-relative">
            <img src={Image5} alt={Image5} />
          </div>
        </Container>
      </div>

      <hr className="m-0" />

      <Container>
        <Row className="case_content_box">
          <Col lg={12} className="px-3">
            <div className="case_content p-3">
              <h2 className="case_heading">About</h2>
              <p>
                Auxilo Network is a cutting-edge safety and emergency management
                platform designed to connect citizens, police departments, and
                agents for real-time emergency response. The platform includes
                features such as a real-time crime map, a sex offender map, and
                an emergency management system that helps users report incidents
                quickly and efficiently. By enabling agents and departments to
                collaborate in real time, Auxilo Network enhances public safety
                and provides citizens with the control they need to manage their
                safety.
              </p>
              <p>
                Auxilo Network supports cross-country operations, allowing
                departments and agents to register and coordinate across
                different regions. The platform integrates a user-friendly
                mobile app for citizens, a police department app, and an agent
                app, all of which provide real-time notifications, tracking, and
                incident management features. The platform is designed to help
                citizens stay safe and make it easier for emergency responders
                to act swiftly and accurately.
              </p>
            </div>
          </Col>
        </Row>
      </Container>

      <Container className=" my-5">
        <div className="process px-3">
          <h2 className="case_heading">Process</h2>
          <Row className="mt-4 justify-content-center">
            {caseStudiesProcess.map((step, index) => (
              <Col lg={3} md={4} sm={6} key={index} className="mb-3">
                <div className="card">
                  <span>{step.step}</span>
                  {step.icon}
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </Container>

      <Container className=" my-5">
        <Row className="mt-5 client_benefits align-items-center">
          <Col md={6}>
            <h2 className="case_heading">Client Benefits</h2>
            <ul className="mt-4 p-0">
              <li className="d-flex align-items-center gap-2">
                <IoMdStar />
                Real-Time Crime Mapping and Alerts:
              </li>
              <li className="d-flex align-items-center gap-2">
                <IoMdStar />
                Emergency Management System:
              </li>
              <li className="d-flex align-items-center gap-2">
                <IoMdStar />
                Cross-Country Coordination
              </li>
              <li className="d-flex align-items-center gap-2">
                <IoMdStar />
                Real-Time Agent Tracking.
              </li>
              <li className="d-flex align-items-center gap-2">
                <IoMdStar />
                User-Friendly Mobile Apps and Web Access
              </li>
              <li className="d-flex align-items-center gap-2">
                <IoMdStar />
                Improved Public Safety
              </li>
            </ul>
          </Col>
          <Col md={6}>
            <img src={client} alt={client} className="img-fluid" />
          </Col>
        </Row>
        <hr className="my-5" />

        <div className="challenges my-5">
          <h2 className="case_heading">Challenges </h2>
          <Row className="mt-4 justify-content-center">
            <Col lg={4} className="border_bottom">
              <div className="card position-relative">
                <span> 1</span>
                <h5>Cross-Country Coordination of Emergency Response</h5>
                <p className="mb-1">
                  <b>Challenge</b> : Managing emergency response across multiple
                  countries with varying safety protocols and regulations
                </p>

                <p className="mb-1">
                  <b>Solution</b>: Auxilo Network was developed to support
                  international operations, allowing police departments and
                  agents from different countries to coordinate, track
                  emergencies, and respond according to local protocols.
                </p>
              </div>
            </Col>
            <Col lg={4} className="border-left border_bottom border-right">
              <div className="card position-relative">
                <span> 2</span>
                <h5>Real-Time Emergency Notifications and Tracking</h5>

                <p className="mb-1">
                  <b>Challenge</b> Ensuring real-time communication between
                  users, agents, and police departments.
                </p>

                <p className="mb-1">
                  <b>Solution</b>: The platform integrates real-time tracking
                  and notifications, so users can quickly report incidents, and
                  agents and departments are immediately notified for faster
                  response times.
                </p>
              </div>
            </Col>
            <Col lg={4} className="border_bottom">
              <div className="card position-relative">
                <span> 3</span>
                <h5> Accurate Crime and Offender Mapping</h5>

                <p className="mb-1">
                  <b>Challenge</b>: Providing up-to-date crime data and ensuring
                  accurate mapping of sex offenders.
                </p>

                <p className="mb-1">
                  <b>Solution</b>: Auxilo Network continuously updates crime
                  data from government sources to ensure the most accurate and
                  real-time information is available to users.
                </p>
              </div>
            </Col>
            <Col lg={4} className="border_bottom">
              <div className="card position-relative">
                <span> 4</span>
                <h5>User Privacy and Data Security</h5>

                <p className="mb-1">
                  <b>Challenge</b> : Ensuring the privacy and security of
                  sensitive information, including user reports and incident
                  data.
                </p>

                <p className="mb-1">
                  <b>Solution</b>: The platform is built with robust encryption
                  and privacy protocols to ensure that all data, especially
                  user-uploaded videos, voice recordings, and emergency reports,
                  is securely stored and protected.
                </p>
              </div>
            </Col>
            <Col lg={4} className="border-left border_bottom ">
              <div className="card position-relative">
                <span> 5</span>
                <h5>Instant Communication
</h5>

                <p className="mb-1">
                  <b>Challenge</b>:Ensuring effective communication between drivers, brokers, and shippers in real time, especially when issues arise or clarification is needed.
                </p>

                <p className="mb-1">
                  <b>Solution</b>: Draygo introduces integrated chat features for direct communication between drivers, brokers, and shippers. This reduces the need for phone calls or emails and allows for instant problem-solving
                </p>
              </div>
            </Col>
          </Row>
        </div>

        <div className="process_tab_box">
          <Row className="justify-content-center">
            <Col lg={10} className="process_tab_list">
              <ul className="p-0">
                <li
                  onClick={() => setTabName("Business Needs")}
                  className={`${tabName === "Business Needs" ? "active" : ""}`}
                >
                  Business Needs
                </li>
                <li
                  onClick={() => setTabName("Objectives Achieved")}
                  className={`${
                    tabName === "Objectives Achieved" ? "active" : ""
                  }`}
                >
                  Objectives Achieved
                </li>
                <li
                  onClick={() => setTabName("Technologies Used")}
                  className={`${
                    tabName === "Technologies Used" ? "active" : ""
                  }`}
                >
                  Technologies Used
                </li>
              </ul>
            </Col>
            <Col lg={10} className="mt-4">
              {tabName === "Business Needs" && (
                <div className="tab_content_box">
                  <div className="box">
                    <ol>
                      <li>
                        <h6>
                          <PiArrowBendDownRightBold />
                          Real-Time Crime Mapping
                        </h6>
                        <p>
                          The business needed a platform that provided
                          up-to-date, real-time crime data for users to stay
                          informed about safety concerns in their vicinity.
                        </p>
                      </li>
                      <li>
                        <h6>
                          <PiArrowBendDownRightBold />
                          Emergency Management System
                        </h6>
                        <p>
                          There was a need for a system that enabled citizens to
                          report emergencies quickly, and that allowed agents
                          and police departments to respond promptly and
                          effectively.
                        </p>
                      </li>

                      <li>
                        <h6>
                          <PiArrowBendDownRightBold />
                          Cross-Country Emergency Coordination
                        </h6>
                        <p>
                          The platform had to support cross-country emergency
                          coordination, allowing agents, police departments, and
                          citizens to communicate efficiently and act rapidly,
                          regardless of regional differences.
                        </p>
                      </li>

                      <li>
                        <h6>
                          <PiArrowBendDownRightBold />
                          Real-Time Agent Location and Tracking
                        </h6>
                        <p>
                          The business needed a way for agents and departments
                          to track the location of responders in real time to
                          ensure the fastest response to emergencies.
                        </p>
                      </li>

                      <li>
                        <h6>
                          <PiArrowBendDownRightBold />
                          User-Friendly Access
                        </h6>
                        <p>
                          The platform needed to be accessible for both citizens
                          and emergency responders, with apps for different user
                          roles and a web-based management system.
                        </p>
                      </li>
                    </ol>
                  </div>
                </div>
              )}

              {tabName === "Objectives Achieved" && (
                <div className="tab_content_box">
                  <div className="box">
                    <ol>
                      <li>
                        <p className="p-0 mb-0">
                          <b>
                            Complete Visibility of Crime and Emergency Incidents
                          </b>
                        </p>
                        <p className="p-0">
                          Auxilo Network provides a real-time crime map,
                          allowing users to view and track incidents in their
                          area. Citizens, agents, and police departments have
                          access to the latest criminal activity data, enhancing
                          situational awareness and safety
                        </p>
                      </li>

                      <li>
                        <p className="p-0 mb-0">
                          <b>Fast and Efficient Emergency Response</b>
                        </p>
                        <p className="p-0">
                          Enabling citizens to create emergencies and
                          notifying nearby agents and departments instantly, the
                          platform speeds up response times and ensures that the
                          closest available agent is dispatched.
                        </p>
                      </li>

                      <li>
                        <p className="p-0 mb-0">
                          <b>
                            Seamless Coordination Between Countries and Regions
                          </b>
                        </p>
                        <p className="p-0">
                          Auxilo Network supports cross-country coordination,
                          ensuring that emergency responders can collaborate
                          regardless of geographical barriers. The system adapts
                          to different safety protocols, enabling global
                          operations.
                        </p>
                      </li>

                      <li>
                        <p className="p-0 mb-0">
                          <b>Real-Time Agent Tracking</b>
                        </p>
                        <p className="p-0">
                          Real-time tracking of agents allows users and
                          departments to follow agent locations, ensuring that
                          emergency responders can be directed to incidents
                          quickly and accurately.
                        </p>
                      </li>

                      <li>
                        <p className="p-0 mb-0">
                          <b>Enhanced Communication for Public Safety</b>
                        </p>
                        <p className="p-0">
                          The platform integrates real-time chat functionality,
                          allowing users, agents, and departments to communicate
                          instantly during emergencies. This feature improves
                          the efficiency of response times and fosters better
                          collaboration
                        </p>
                      </li>
                    </ol>
                  </div>
                </div>
              )}

              {tabName === "Technologies Used" && (
                <div className="tab_content_box">
                  <div className="box">
                    <ol>
                      <li>
                        <p className="p-0 mb-2 mt-0">Laravel (Backend) </p>
                      </li>
                      <li>
                        <p className="p-0 mb-2 mt-0">MySQL </p>
                      </li>
                      <li>
                        <p className="p-0 mb-2 mt-0">Livewire (Frontend Framework)</p>
                      </li>
                      <li>
                        <p className="p-0 mb-2 mt-0">GPS & Geolocation</p>
                      </li>
                      <li>
                        <p className="p-0 mb-2 mt-0">Push Notifications</p>
                      </li>
                     
                    </ol>
                  </div>
                </div>
              )}
            </Col>
          </Row>
        </div>
      </Container>

      <MajorClient />
      <Testimonials />
      {/* <ContactForm /> */}
    </div>
  );
};

export default AuxiloNetwork;
